import { __extends } from "tslib";
import { DomainError } from "../DomainError";
import { Optional } from "../Optional";
var UnionDeserializationError = (function (_super) {
    __extends(UnionDeserializationError, _super);
    function UnionDeserializationError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnionDeserializationError;
}(DomainError));
export { UnionDeserializationError };
var Union = (function () {
    function Union(value) {
        this.value = value;
    }
    Union.define = function (config) {
        var _a;
        var classes = config.entries.reduce(function (acc, klass) {
            acc[klass[config.key]] = klass;
            return acc;
        }, {});
        return _a = (function (_super) {
                __extends(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(class_1.prototype, "key", {
                    get: function () {
                        return config.key;
                    },
                    enumerable: false,
                    configurable: true
                });
                class_1.create = function (data) {
                    var value = this.fromJSON(data);
                    if (!value) {
                        throw UnionDeserializationError.create("that could not be deserialized", { details: { data: data, value: value } });
                    }
                    if ("validate" in value) {
                        value.validate();
                    }
                    return value;
                };
                class_1.build = function (data) {
                    if (typeof data !== "object") {
                        return undefined;
                    }
                    var tag = data[config.key];
                    if (!tag) {
                        return undefined;
                    }
                    var klass = config.entries.find(function (entry) { return entry[config.key] === tag; });
                    if (!klass) {
                        return undefined;
                    }
                    return this.fromJSON(data);
                };
                class_1.fromJSON = function (data) {
                    if (data instanceof this) {
                        return data;
                    }
                    if (typeof data !== "object") {
                        return undefined;
                    }
                    var tag = data[config.key];
                    if (!tag) {
                        return undefined;
                    }
                    var klass = config.entries.find(function (entry) { return entry[config.key] === tag; });
                    if (!klass) {
                        return undefined;
                    }
                    return new this(klass.create(data));
                };
                return class_1;
            }(Union)),
            _a.entries = config.entries,
            _a.typeList = config.entries.map(function (value) { return value[config.key]; }),
            _a.classes = classes,
            _a;
    };
    Object.defineProperty(Union.prototype, "key", {
        get: function () {
            throw new Error("Not implemented");
        },
        enumerable: false,
        configurable: true
    });
    Union.prototype.is = function (type) {
        var _this = this;
        return Optional.of(this.value).filter(function (value) { return value[_this.key] === type; });
    };
    Union.prototype.allCases = function (cased) {
        var key = this.value[this.key];
        var caseFn = cased[key];
        return caseFn(this.value);
    };
    Object.defineProperty(Union.prototype, "merged", {
        get: function () {
            return this.value;
        },
        enumerable: false,
        configurable: true
    });
    Union.prototype.asJSON = function () {
        return this.value.asJSON();
    };
    Union.prototype.toJSON = function () {
        return this.value.asJSON();
    };
    Union.prototype.__class = function () {
        throw new Error("Not implemented");
    };
    Union.prototype.__attributes = function () {
        return this.value;
    };
    return Union;
}());
export { Union };
